import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
} from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

export interface IProject {
  id: string;
  name: string;
  ownerUserId: string;
  userIds: string[];
}

export class FireStoreProject {
  private projectDoc: AngularFirestoreDocument<any>;

  constructor(
    private afs: AngularFirestore,
    private id: string,
  ) {
    this.projectDoc = this.afs.doc<any>(`projects/${this.id}`);
  }

  get data$(): Observable<IProject> {
    return this.projectDoc.valueChanges().map(m => {
      if (!m) { return null; }
      return <IProject>Object.assign({}, { id: this.id}, m);
    });
  }

  static add(afs: AngularFirestore, data: IProject): IProject {
    const id = afs.createId();
    data = Object.assign(data, {id});
    afs.doc(`projects/${id}`).set(data);
    return data;
  }

  update(data: IProject) {
    this.afs.doc(`projects/${this.id}`).update(data);
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/firestore/models/project.ts